/** Loading placeholder — shimmer runs on a translated overlay (styles/primitives.css). */
export function Skeleton({ lines = 3, width, height = 13 }: { lines?: number; width?: string; height?: number }) {
  return (
    <div aria-hidden="true">
      {Array.from({ length: lines }, (_, i) => (
        <div
          key={i}
          className="skeleton"
          style={{ height, marginBottom: 8, width: width ?? (i === lines - 1 ? '60%' : '100%') }}
        />
      ))}
    </div>
  );
}
